export default __webpack_public_path__ + "static/media/diagnostics.fd857457.svg";